var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 469.44 469.44",
    viewBox: "0 0 469.44 469.44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m231.147 160.373 67.2 67.2.32-3.52c0-35.307-28.693-64-64-64z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m234.667 117.387c58.88 0 106.667 47.787 106.667 106.667 0 13.76-2.773 26.88-7.573 38.933l62.4 62.4c32.213-26.88 57.6-61.653 73.28-101.333-37.013-93.653-128-160-234.773-160-29.867 0-58.453 5.333-85.013 14.933l46.08 45.973c12.052-4.693 25.172-7.573 38.932-7.573z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m21.333 59.253 48.64 48.64 9.707 9.707c-35.2 27.52-63.04 64.107-79.68 106.453 36.907 93.653 128 160 234.667 160 33.067 0 64.64-6.4 93.547-18.027l9.067 9.067 62.187 62.293 27.2-27.093-378.135-378.24zm117.974 117.867 32.96 32.96c-.96 4.587-1.6 9.173-1.6 13.973 0 35.307 28.693 64 64 64 4.8 0 9.387-.64 13.867-1.6l32.96 32.96c-14.187 7.04-29.973 11.307-46.827 11.307-58.88 0-106.667-47.787-106.667-106.667 0-16.853 4.267-32.64 11.307-46.933z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeLock);
export default __webpack_public_path__ + "static/media/eye-lock.934452e75c23f82002d2129613ac088b.svg";
export { ForwardRef as ReactComponent };